/**
 * Build an E.164 phone number from an editable dial code (e.g. `+27`) and a
 * locally-typed number. Strips a leading `0`, and avoids double-prefixing if
 * the local part already starts with the dial digits.
 */
export function buildE164(dialCode: string, local: string): string {
  const localDigits = local.replace(/\D/g, '');
  if (!localDigits) return '';
  const dialDigits = dialCode.replace(/\D/g, '') || '27';
  if (localDigits.startsWith(dialDigits)) return `+${localDigits}`;
  return `+${dialDigits}${localDigits.replace(/^0+/, '')}`;
}
